import React from 'react';
import { useDispatch } from 'react-redux';
import {setLikeFormId } from '../../../redux/slices/likeFormIdSlice';
import {setLikeCollectionId } from '../../../redux/slices/likeCollectionIdSlice';
import { FETCH_LIKE, FETCH_DISLIKE, FETCH_LIKE_COLLECTION, FETCH_DISLIKE_COLLECTION, FETCH_PRODUCT_MODAL_DATA_LIST, FETCH_COLLECTION_MODAL_DATA_LIST } from '../../../redux/actions';

const LikeButton = ({ modalData, data, toggleLike, likedItems }) => {
    const dispatch = useDispatch();

    const handleLikeForm = (id) => {
        toggleLike(id, likedItems[id]);
        if (data.is_collection) {
            dispatch(setLikeCollectionId(id))
            dispatch({type: FETCH_LIKE_COLLECTION})
            dispatch({type: FETCH_COLLECTION_MODAL_DATA_LIST})

        } else {
            dispatch(setLikeFormId(id))
            dispatch({type: FETCH_LIKE})
            dispatch({type: FETCH_PRODUCT_MODAL_DATA_LIST})
        }
    }


    const handleDislikeForm = (id) => {
        toggleLike(id, likedItems[id]);
        if (data.is_collection) {
            dispatch(setLikeCollectionId(id))
            dispatch({type: FETCH_DISLIKE_COLLECTION})
            dispatch({type: FETCH_COLLECTION_MODAL_DATA_LIST})
        } else {
            dispatch(setLikeFormId(id))
            dispatch({type: FETCH_DISLIKE})
            dispatch({type: FETCH_PRODUCT_MODAL_DATA_LIST})

        }

    }



    return (
        <div className='modal-like'>
            {modalData?.is_favoured_by_user || (likedItems && likedItems[modalData.id]) ? (
                <span
                    style={{width: 21, height: 21}}
                    className="heart-icon-modal liked"
                    onClick={() => handleDislikeForm(modalData?.id)}
                />
            ) : (
                <span
                    style={{width: 21, height: 21}}
                    className="heart-icon-modal"
                    onClick={() => handleLikeForm(modalData?.id)}
                />
            )}
        </div>
    );
};

export default LikeButton;
